import { DrawerProps } from "@mui/material";
import StyledDrawer from "Components/UI/StyledDrawer";
import { ChartBuilderAttributes } from "features/chartLibrary";
import { useSelectedAttributes } from "..";

interface IAnalayticsFilterDrawerProps extends DrawerProps { }

function AnalayticsFilterDrawer({ open, onClose }: IAnalayticsFilterDrawerProps) {
  const { selectedAttributes, setSelectedAttributes } = useSelectedAttributes();
  return <StyledDrawer open={open} onClose={onClose} maxWidth={600}>
    <ChartBuilderAttributes
      title="Filters"
      subTitle="Select the filters you want to apply to this report"
      attributes={selectedAttributes}
      setAttributes={setSelectedAttributes}
    />
  </StyledDrawer>
}

export default AnalayticsFilterDrawer;